"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANVA_IMPORT_VIDEO_MAX_BYTES = exports.CANVA_EXPORT_MAX_POLL_MS = exports.CANVA_DESIGN_EXPORT_LIMIT_5MIN = exports.CANVA_USER_EXPORT_LIMIT_24H = exports.CANVA_USER_EXPORT_LIMIT_5MIN = exports.CANVA_INTEGRATION_EXPORT_BLOCK_24H = exports.CANVA_INTEGRATION_EXPORT_LIMIT_24H = exports.CANVA_INTEGRATION_EXPORT_LIMIT_5MIN = exports.CANVA_MAX_BATCH_SIZE = exports.CANVA_LARGE_BATCH_EMAIL_THRESHOLD = exports.DEFAULT_CANVA_SYNC_SETTINGS = void 0;
exports.maxBytesForCanvaImportFormat = maxBytesForCanvaImportFormat;
exports.matchesCanvaDateFilter = matchesCanvaDateFilter;
exports.matchesCanvaAssetFilter = matchesCanvaAssetFilter;
exports.DEFAULT_CANVA_SYNC_SETTINGS = {
    autoSyncOnReturn: true,
    bulkReplaceOnUpdate: true,
    pollForUpdates: false,
};
exports.CANVA_LARGE_BATCH_EMAIL_THRESHOLD = 15;
exports.CANVA_MAX_BATCH_SIZE = 25;
/** Canva Connect published limits (PRD §6.6). */
exports.CANVA_INTEGRATION_EXPORT_LIMIT_5MIN = 750;
exports.CANVA_INTEGRATION_EXPORT_LIMIT_24H = 5000;
/** Block new exports slightly below the hard cap. */
exports.CANVA_INTEGRATION_EXPORT_BLOCK_24H = 4800;
exports.CANVA_USER_EXPORT_LIMIT_5MIN = 75;
exports.CANVA_USER_EXPORT_LIMIT_24H = 500;
exports.CANVA_DESIGN_EXPORT_LIMIT_5MIN = 75;
/** PRD: poll export jobs up to ~60s per design. */
exports.CANVA_EXPORT_MAX_POLL_MS = 60000;
/** Canva MP4 exports may exceed the standard 40 MB upload cap. */
exports.CANVA_IMPORT_VIDEO_MAX_BYTES = 100 * 1024 * 1024;
function maxBytesForCanvaImportFormat(format, mediaMaxBytes) {
    return format === "mp4" ? exports.CANVA_IMPORT_VIDEO_MAX_BYTES : mediaMaxBytes;
}
const DAY_MS = 24 * 60 * 60 * 1000;
/** Whether a design's last-modified date falls within the date filter. */
function matchesCanvaDateFilter(updatedAt, filter) {
    if (filter === "all") {
        return true;
    }
    const updatedMs = new Date(updatedAt).getTime();
    const cutoffDays = filter === "last7" ? 7 : filter === "last30" ? 30 : 90;
    return Date.now() - updatedMs <= cutoffDays * DAY_MS;
}
/** Whether a design should appear under the given browse filter. */
function matchesCanvaAssetFilter(assetType, filter) {
    if (filter === "all") {
        return true;
    }
    // Filter by the same primary type used for automatic import format.
    return assetType === filter;
}
